module.exports = __webpack_public_path__ + "img/vk.b03024c4.svg";